import { ModuleKind } from "src/adminPanel/modulesV2/constants";
import { Module } from "src/api/modulesApi";
import { PillVariants } from "src/base-components/Pill";
import { ModuleOperationStatus } from "src/clients/flow-api";

export const groupModulesByKind = (
  modules: Module[],
): Record<ModuleKind, Module[]> => {
  const groups = Object.fromEntries(
    Object.values(ModuleKind).map((kind) => [kind, [] as Module[]]),
  ) as Record<ModuleKind, Module[]>;

  const validKinds = new Set<string>(Object.values(ModuleKind));

  for (const mod of modules) {
    if (validKinds.has(mod.kind)) {
      groups[mod.kind as ModuleKind].push(mod);
    }
  }

  return groups;
};

export const getOperationStatusPillVariant = (
  status: ModuleOperationStatus,
): PillVariants => {
  switch (status) {
    case ModuleOperationStatus.COMPLETED:
      return "green";
    case ModuleOperationStatus.IN_PROGRESS:
    case ModuleOperationStatus.PENDING:
      return "yellow";
    case ModuleOperationStatus.FAILED:
      return "red";
    case ModuleOperationStatus.SCHEDULED:
    case ModuleOperationStatus.CANCELLED:
      return "gray";
  }
};

export const filterModulesBySearchTerm = (
  modules: Module[],
  searchTerm: string,
  workspaceMap: Map<string, { name: string; orgId: string; slug: string }>,
  orgMap: Map<string, string>,
): Module[] => {
  if (!searchTerm) return modules;
  const lower = searchTerm.toLowerCase();
  return modules.filter((mod) => {
    const ws = workspaceMap.get(mod.workspaceId);
    const { name, slug, orgId } = ws ?? {};
    const orgName = orgId ? orgMap.get(orgId) : undefined;
    return (
      mod.workspaceId.toLowerCase().includes(lower) ||
      mod.id.toLowerCase().includes(lower) ||
      mod.kind.toLowerCase().includes(lower) ||
      name?.toLowerCase().includes(lower) ||
      slug?.toLowerCase().includes(lower) ||
      orgName?.toLowerCase().includes(lower)
    );
  });
};

export const truncateJson = (
  obj: Record<string, unknown>,
  maxLength = 120,
): string => {
  const str = JSON.stringify(obj);
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + "…";
};
